import styled from 'styled-components'

export const ShopDetailContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow:auto;
  background-color: rgba(255, 255, 255, 1);
  z-index: 1000;
  opacity: 0;
`;

export const CloseButton = styled.button`
  position: fixed;
  top: 2.2vw;
  right: 2vw;
  width: 2vw;
  height: 2vw;
  font-size: 2vw;
  @media only screen and (max-width: 900px) {
    width: 6vw;
    height: 6vw;
    font-size: 6vw;
  }
  z-index: 1001;
  cursor: pointer;
  opacity: 0.6;
  transition: all 0.5s;
  &:hover {
    opacity: 1;
  }
  background-color: transparent;
  border-width: 0;
`;

export const ProductDataContainer = styled.div`
  display: flex;
  margin-top: 4vw;
  align-items: flex-start;
  justify-content: center;
  background-color: white;
  padding: 25px;
  > div {
    width: 45%;
    @media only screen and (max-width: 900px) {
      width: 100%;
    }
  }
  @media only screen and (max-width: 900px) {
    flex-direction: column;
  }
`;

export const ProductDataTitle = styled.div`
  font-size: 1.6em;
  font-weight: bold;
  text-align: center;
  margin-top: 4vw;
`;

export const ProductDataDescription = styled.div`
  font-size: 1.2em;
  margin: 1vw 0;
`;

export const AddToCartButton = styled.button`
  background-color: rgba(0, 0, 0, 1);
  color: white;
  border-width: 0;
  padding: 1.5em 2.5em;
  cursor: pointer;
  &:hover {
    background-color: rgba(0, 0, 0, 0.8);
  }
  &:disabled {
    background-color: rgba(0, 0, 0, 0.6) !important;
    cursor: default !important;
    opacity: 0.6;
  }
  .addingToCartIcon {
    margin-right: 1em;
    font-size: 1.2em;
  }
`;

export const GoToCartButton = styled.button`
  background-color: rgba(0, 131, 25, 1);
  color: white;
  border-width: 0;
  padding: 1.5em 2.5em;
  cursor: pointer;
  &:hover {
    background-color: rgba(0, 131, 25, 0.8);
  }
  &:disabled {
    background-color: rgba(0, 131, 25, 0.6) !important;
    cursor: default !important;
    opacity: 0.6;
  }
  .addedToCartIcon {
    margin-right: 1em;
    font-size: 1.2em;
    svg, path {
      color: white !important;
    }
  }
`;

export const ContinueShoppingButton = styled.button`
  background-color: transparent;
  color: black;
  border-width: 0;
  padding: 1.5em;
  cursor: pointer;
  opacity: 0.8;

  &:hover {
    opacity: 1;
  }
`;

export const title = styled.h1`
  text-align: center;
  font-size: 4vw;
  @media only screen and (max-width: 900px) {
    font-size: 9vw;
  }
  &.mobileVersion {
    font-size: 9vw;
  }
  line-height: 1em;
  margin-top: 2vw;
  margin-bottom: 2vw;
`;
